import { FUSION, ONLY_MOBILE } from '@/constants/constants';
import { getNewHaveThisDetUsage, getSpecificDetailedUsage } from '@/utils/dataHandlers/UsageDataHandler';
import { obtenerFechasCicloFacturacion } from '@/utils/utils';

export const calculateTotalExtraOfAnAccUsage = (accUsages) => {
  let totalExtra = 0;
  const {
    data,
    others,
    sms,
    voice,
  } = accUsages;

  if (data && data.extra) { totalExtra += data.extra; }
  if (others && others.extra) { totalExtra += others.extra }
  if (sms && sms.extra) { totalExtra += sms.extra }
  if (voice && voice.extra) { totalExtra += voice.extra }

  return totalExtra;
}
export const normalizeAccUsage = (rawData, currentItem) => {
  let accUsageNormalized = null;
  let productsCycleInfo = null;
  try {
    if (rawData && rawData.accumulatedUsage) {
      const usages = rawData.accumulatedUsage[0];
      const { franquiciaIlimitada } = rawData;
      accUsageNormalized = usages;
      accUsageNormalized.others = accUsageNormalized.other;
      accUsageNormalized.franquiciaIlimitada = franquiciaIlimitada;
      delete accUsageNormalized.other;
      accUsageNormalized.kindProduct = currentItem.kindProduct;
      accUsageNormalized.totalExtra = calculateTotalExtraOfAnAccUsage(accUsageNormalized);
      if (currentItem.kindProduct === 'mobile' || currentItem.kindProduct === 'phone') {
        accUsageNormalized.phoneNumber = currentItem.number;
      }

      /* ****** STARTS TOKENIZATION CATALOGUE CASE WHEN CLIENT HAS A 48H UNLIMITED DATA BONU ******** */
      // Case when Tokenization Unlimited Bonu Data === maxValue 2TB -> 2147483648 kb
      /* if (currentItem.kindProduct === 'mobile'
      && accUsageNormalized.data.maxValue > 2147483648) {
        accUsageNormalized.data.maxValue = -2;
      } */
      // Fake vaLue to check logic is working
      /* if (currentItem.kindProduct === 'mobile' && accUsageNormalized.data.maxValue > 30457280) {
        accUsageNormalized.data.maxValue = -2;
      } */
      /* ****** ENDS TOKENIZATION CATALOGUE CASE WHEN CLIENT HAS A 48H UNLIMITED DATA BONU ******** */

      // billCycling
      const { dateEndCycleBilling, dateStartCycleBilling, remainingDays } = rawData;
      if (dateEndCycleBilling && dateStartCycleBilling && remainingDays != null) {
        productsCycleInfo = {
          startCycle: dateStartCycleBilling,
          endCycle: dateEndCycleBilling,
          remainingDays,
        }
      } else {
        const { dateEndCycleBilling, dateStartCycleBilling, remainingDays } = obtenerFechasCicloFacturacion();
        productsCycleInfo = {
          startCycle: dateStartCycleBilling,
          endCycle: dateEndCycleBilling,
          remainingDays,
        }
      }
    }
  } catch (err) {
    console.warn(err);
    return {
      accUsageNormalized,
      productsCycleInfo,
    };
  }
  return {
    accUsageNormalized,
    productsCycleInfo,
  };
}
//
export const calculateMainMobileLine = (allAccumulatedUsages, hiredProducts) => {
  // create an array only with the specials bundles
  const fusionOrHashtagBundle = [];
  hiredProducts.forEach((bundle) => {
    const { productType } = bundle;
    if (productType === FUSION || productType === ONLY_MOBILE) {
      fusionOrHashtagBundle.push(bundle);
    }
  })
  // lets have a look inside every bundle, and see if we have all his usagesFetched
  const bundleWithUsages = {};
  const bundleWithAllUsages = [];
  fusionOrHashtagBundle.forEach((bundle) => {
    const { mobile } = bundle;
    if (mobile) {
      const { linesMobile } = mobile;
      const numberOfLines = linesMobile.length;
      let numberOfUsages = 0;
      linesMobile.forEach((itemLine) => {
        const { productId } = itemLine;
        const hisUsage = allAccumulatedUsages.find(usage => usage.productId === productId);
        if (hisUsage) {
          if (!(bundleWithUsages[bundle.productId])) {
            bundleWithUsages[bundle.productId] = {};
          }
          if (!(bundleWithUsages[bundle.productId][hisUsage.productId])) {
            bundleWithUsages[bundle.productId][hisUsage.productId] = hisUsage;
          }
          numberOfUsages += 1;
        }
      })
      if (numberOfUsages === numberOfLines) {
        bundleWithAllUsages.push(bundle)
      }
    }
  })
  // Finaly we have got the bundle that satisfies all conditions
  const finalRes = [];
  bundleWithAllUsages.forEach((bundle) => {
    const { mobile } = bundle;
    if (mobile) {
      const { linesMobile } = mobile;
      let mainProductId = null;
      const lastMaxValue = 0;
      try {
        linesMobile.forEach((item) => {
          const currentUsage = bundleWithUsages[bundle.productId][item.productId];
          const { data } = currentUsage;
          const { maxValue } = data
          if (maxValue > lastMaxValue) {
            mainProductId = item.productId;
          }
          if (lastMaxValue === maxValue) {
            const productNumberId = parseInt(item.productId);
            const lastProductNumberId = parseInt(mainProductId);
            if (productNumberId < lastProductNumberId) {
              mainProductId = item.productId;
            }
          }
        })
        finalRes.push({
          bundle: bundle.productId,
          mainProductId,
        })
      } catch (err) {
        return null;
      }
    }
  })

  return finalRes;
}


export const appendMainLine2HiredProducts = (hiredProducts, mainProductId) => {
  const newHiredProducts = hiredProducts.map((bundle) => {
    const currentBundle = bundle;
    let newLinesMobile = null;
    if (bundle.mobile && bundle.mobile.linesMobile) {
      newLinesMobile = bundle.mobile.linesMobile.map((itemLineMobile) => {
        const newItemLineMobile = itemLineMobile;
        const hasMainThisLine = mainProductId.find(item => item.mainProductId === newItemLineMobile.productId);
        if (hasMainThisLine) {
          newItemLineMobile.main = true;
        }
        return newItemLineMobile;
      })
    }
    // Si hay nuevas lines mobiles lo concateno siempre tenga main o no
    if (newLinesMobile) {
      currentBundle.mobile.linesMobile = newLinesMobile;
    }
    return currentBundle;
  });

  return newHiredProducts;
}

export const normalizeDetailedByType = (response, currentSlide, haveThisDetUsage, kindProduct, productId) => {
  let detailedUsages = null;
  if (response && response.detailUsage) {
    detailedUsages = response.detailUsage[0];
  }
  let specificDetailedUsage = []
  let newHaveThisDetUsage = []
  if (haveThisDetUsage) {
    if (detailedUsages) {
      specificDetailedUsage = getSpecificDetailedUsage(currentSlide, detailedUsages, kindProduct);
    } else {
      specificDetailedUsage = [];
    }
    specificDetailedUsage.moreElements = response.moreElements;
    specificDetailedUsage.pageNumber = response.pageNumber;
    newHaveThisDetUsage = getNewHaveThisDetUsage(haveThisDetUsage, specificDetailedUsage, currentSlide, kindProduct);
  } else if (detailedUsages) {
    specificDetailedUsage = getSpecificDetailedUsage(currentSlide, detailedUsages, kindProduct);
    detailedUsages.alreadyRequest = [];
    specificDetailedUsage.moreElements = response.moreElements;
    specificDetailedUsage.pageNumber = response.pageNumber;
    newHaveThisDetUsage = getNewHaveThisDetUsage(detailedUsages, specificDetailedUsage, currentSlide, kindProduct);
  } else {
    detailedUsages = {}
    detailedUsages.alreadyRequest = [];
    detailedUsages.productId = productId;
    newHaveThisDetUsage = getNewHaveThisDetUsage(detailedUsages, specificDetailedUsage, currentSlide, kindProduct);
    // detailedUsages = getNewHaveThisDetUsage(detailedUsages, specificDetailedUsage, currentSlide, kindProduct);
  }

  return newHaveThisDetUsage;
}


export const appendBonusToHiredProducts = (hiredProducts, bonusInfo) => {
  // Recorro el hired products
  const bundlesId = Object.keys(hiredProducts);
  const newHiredProducts = bundlesId.map((bundleIndex) => {
    const currentBundle = hiredProducts[bundleIndex];
    const bundleId = currentBundle.productId;
    // ya tengo el bundle ahora saco todos los keys de los mobiles de bonus bonusInfo
    let newLinesMobiles = null;
    if (currentBundle.mobile && currentBundle.mobile.linesMobile) {
      newLinesMobiles = currentBundle.mobile.linesMobile.map((itemLine) => {
        let bonusOfThisLine = null;
        const newItemLine = itemLine;
        if (!newItemLine.main) {
          newItemLine.main = false;
        }
        // si tengo info nueva se la reemplazo y sino dejo la anterior
        if (bonusInfo[bundleId] && bonusInfo[bundleId][itemLine.productId]) {
          bonusOfThisLine = bonusInfo[bundleId][itemLine.productId];
        } else if (itemLine.bonus) {
          bonusOfThisLine = itemLine.bonus;
        }


        return {
          ...newItemLine,
          bonus: bonusOfThisLine,
        }
      })
    }
    if (newLinesMobiles) {
      currentBundle.mobile.linesMobile = newLinesMobiles;
    }
    return currentBundle;
  });

  return [
    ...newHiredProducts,
  ];
}